module.exports = __webpack_public_path__ + "static/media/chrome-permissions.8e105c31.jpeg";